module.exports = __webpack_public_path__ + "static/media/medpad-slide2.bad98dc9.png";